import React from "react";
import EbDialog from "../../ExecutionBlueprint/ExecutionBlueprintLiveReview/_shared/EbDialog";
import "../../ExecutionBlueprint/ExecutionBlueprintReview/InfoDialog.scss";

// ═════════════════════════════════════════════════════════════════════════════
// "How live review works" — the explainer behind the header icon on the live
// review screen, and auto-opened the first time either party reaches it.
//
// The Annual OKR counterpart of the Execution Blueprint's
// `LiveReviewInfoModal`, on the same shared `EbDialog` and reusing
// `InfoDialog.scss`'s numbered list. Only the copy differs.
//
// ⚠️ SHOWN TO BOTH PARTIES, so the copy is written for whoever is reading. EXW's
// version is coach-only ("your solo review is done") — this screen is the one
// place in the product where the same component renders for a CEO and a coach
// at the same moment, and telling the CEO about "your solo review" would be
// describing work they never did. `viewerRole` picks the one line that has to
// differ; everything else is true for both.
// ═════════════════════════════════════════════════════════════════════════════

const STEPS = [
  <>
    Check everyone has joined — a green dot next to each person&apos;s name,
    beside the title, means they&apos;re connected
  </>,
  <>
    Work down the objectives together, editing or adding as you agree changes
  </>,
  <>
    Clear every item on the <strong>Meeting Agenda</strong> as you talk it
    through
  </>,
  <>
    <strong>Lock the Annual OKRs</strong> once nothing is left to discuss
  </>,
];

const LiveReviewInfoModal = ({ viewerRole, onClose }) => (
  <EbDialog
    isOpen
    size="lg"
    // Neutral: this explains rather than asks, and a teal chip would give it the
    // weight of a decision.
    tone="neutral"
    title="Run the live review"
    // JK copy review O12: the Execution Blueprint's line, and JK's working
    // model — the leadership team is in the session too.
    subtitle={
      viewerRole === "coach"
        ? "Run this with the CEO and their leadership team, in person or on a video call."
        : "Run this with your coach and your leadership team, in person or on a video call."
    }
    onClose={onClose}
    actions={[
      { label: "Okay", variant: "primary", onClick: onClose, autoFocus: true },
    ]}
  >
    <p>
      {viewerRole === "coach"
        ? "Your review is done, so now you'll work through it with the CEO."
        : "Your coach has been through your OKRs and is ready to talk them through with you."}{" "}
      The <strong>Meeting Agenda</strong> on the right is the running order —
      every objective flagged to discuss, plus every comment left on the review.
    </p>
    <p>
      Either of you can accept an objective, edit one, add a new one or remove
      one, and you both see every change as it happens.
    </p>

    <ol className="info-steps">
      {STEPS.map((step, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={index}>{step}</li>
      ))}
    </ol>

    <p>
      <strong>Locking is final.</strong> It ends the session for both of you and
      closes the OKRs for the year, so it only unlocks once every agenda item is
      marked discussed.
    </p>
  </EbDialog>
);

export default LiveReviewInfoModal;
